const NEWS = [
    {
        id: 392755,
        index: "01",
        title: "乘风破浪海量福利"
    },
    {
        id: 392756,
        index: "02",
        title: "兄弟同行PK争霸"
    },
    {
        id: 392757,
        index: "03",
        title: "你消费我买单超值回馈"
    },
    {
        id: 392758,
        index: "04",
        title: "金鸡再现真金回馈 "
    },
    {
        id: 392759,
        index: "05",
        title: "完美蝶鸢福利回馈 "
    },
    {
        id: 392760,
        index: "06",
        title: "限定装备新区冲级"
    },
    {
        id: 392761,
        index: "07",
        title: "至臻之力助力冲级"
    },
    {
        id: 392762,
        index: "08",
        title: "新区神宠限定称号"
    },
    {
        id: 392763,
        index: "09",
        title: "至臻豪礼新区特惠"
    },
    {
        id: 392764,
        index: "10",
        title: "开区冲级豪礼相赠"
    },
    {
        id: 392765,
        index: "11",
        title: "尊享象征新区助兴"
    },
    {
        id: 392766,
        index: "12",
        title: "披荆斩棘万人膜拜"
    }
];

export default NEWS;
